<template>
  <div id="register">
    <header>
      <div class="content">
        <span>欢迎使用中资云企业综合服务平台</span>
      </div>
    </header>
    <!-- 注册 -->
    <div class="content reg" v-if="regContent">
      <div class="titleBox flex-between">
        <div class="left">
          <router-link to="login">
            <img src="../assets/imgs/register/titleLogo.png" alt />
          </router-link>
          <span>忘记密码</span>
        </div>
        <div class="right">
          <p>
            我已注册,
            <router-link to="/login">立即登录</router-link>
          </p>
        </div>
      </div>
      <div class="progress flex-between">
        <div class="item flexrcc" :class="step == 1 ? 'active' : ''">
          <div class="step" v-show="step == 1">1</div>
          <div class="stepFinish" v-show="step == 2">
            <img src="../assets/imgs/register/finshed.png" alt />
          </div>
          <span>忘记密码</span>
        </div>
        <div class="line">
          <img src="../assets/imgs/register/line.png" alt />
        </div>
        <div class="item" :class="step == 2 ? 'active' : ''">
          <div class="step">2</div>
          <!-- <div class="stepFinish">
            <img src="../assets/imgs/register/finshed.png" alt />
          </div> -->
          <span>设置完成</span>
        </div>
      </div>
      <div class="registerBox">
        <div class="firstStep" v-if="step == 1">
          <div class="title">
            <p>忘记密码</p>
          </div>
          <div class="inputBox">
            <div class="line">
              <p>手机号</p>
              <input :class="[
                  inputIndex == 1 ? 'active' : '',
                  errorType == 1 ? 'error-active' : '',
                ]" type="text" placeholder="请输入手机号" @focus="inputChange(1)" @blur="inputIndex = 0" @input="inputPhone" v-model="phone" oninput="value=value.replace(/[^\d]/g,'')" maxlength="11" />
              <div v-if="errorType == 1" class="errorTip">
                {{ errorTip }}
              </div>
            </div>
            <div class="line">
              <p>短信验证码</p>
              <div class="flexrbc">
                <input :class="[
                    inputIndex == 2 ? 'active' : '',
                    errorType == 2 ? 'error-active' : '',
                  ]" class="sms" type="text" placeholder="请输入短信验证码" @focus="inputChange(2)" @blur="inputIndex = 0" @input="inputSms" v-model="blNum" oninput="value=value.replace(/[^\d]/g,'')" />
                <div class="getsms" :class="smsSent ? 'sms-sent' : 'sms-send'" @click="getSms">
                  {{ cName }}{{ time }}
                </div>
              </div>
              <div v-if="errorType == 2" class="errorTip2">
                {{ errorTip }}
              </div>
            </div>
            <div class="line relative">
              <p>设置密码</p>
              <div class="input">
                <input id="input3" :class="[
                    inputIndex == 3 ? 'active' : '',
                    errorType == 3 || errorType == 5 ? 'error-active' : '',
                  ]" type="password" placeholder="请输入密码" @focus="inputChange(3)" @blur="inputIndex = 0" @input="passStrong" v-model="password" />
                <div v-if="errorType == 3" class="errorTip">
                  {{ errorTip }}
                </div>
                <div class="strength flex-around-center">
                  <div class="item" :class="passStrongType >= 1 ? 'strongActive' : ''">
                    弱
                  </div>
                  <div class="item" :class="passStrongType >= 2 ? 'strongActive' : ''">
                    中
                  </div>
                  <div class="item" :class="passStrongType >= 3 ? 'strongActive' : ''">
                    强
                  </div>
                </div>
              </div>
            </div>
            <div class="line">
              <p>确认密码</p>
              <input :class="[
                  inputIndex == 4 ? 'active' : '',
                  errorType == 4 || errorType == 5 ? 'error-active' : '',
                ]" type="password" placeholder="请再次输入密码" @focus="inputChange(4)" @blur="inputIndex = 0" @input="inputComfirm" v-model="rpassword" />
              <div v-if="errorType == 4 || errorType == 5" class="errorTip">
                {{ errorTip }}
              </div>
            </div>
            <button class="next" :class="allFill ? 'next-active' : 'next-normal'" @click="tijiao">
              确定
            </button>
          </div>
        </div>
        <div class="secondStep" v-if="step == 2">
          <div class="title">新密码设置完成</div>
          <div class="content-box flexc0c">
            <img src="../assets/imgs/register/success.png" alt="" />
            <!-- <p>您已经设置新密码，点击<span @click="">立即登录</span></p> -->
            <p>
              您已经设置新密码，点击<router-link to="/login">立即登录</router-link>
            </p>
            <p>即可登录中资云企业综合服务平台</p>
          </div>
          <div class="bottom">{{ jumpTime }}秒后系统自动跳转</div>
        </div>
      </div>
    </div>

    <footer>
      <div class="top">
        <div class="content">
          <p>欢迎您使用中资云企业综合服务平台</p>
          <p>
            <span>技术支持</span>
            <img src="../assets/imgs/register/bottomLogo.png" alt class="bottomLogo" />
          </p>
        </div>
      </div>
      <div class="bottom">
        <span>Copyright@2015-2020 河南省非煤矿山管理办公室&中资互联网科技有限公司
          All right Reserveds</span>
      </div>
    </footer>
    <!-- 已注册弹出框 -->
    <div class="alertMask" v-show="register">
      <div class="alert">
        <div class="alertBox">
          <div class="alertTitle">
            <span>提示</span>
            <img src="../assets/imgs/login/close.png" alt @click="register = true" />
          </div>
          <div class="alertContent">
            <div class="title">该企业已注册中资云账号，请直接登录！</div>
            <div class="middle">
              <p>如忘记账号或密码，可致电或前往所属市县交易中心找回。</p>
              <div class="bg">
                <p class="bgTitle">渑池县交易中心</p>
                <div class="msgBox">
                  <div class="msgItem">
                    <img src="../assets/imgs/register/phone.png" alt />
                    <span class="msgTit">联系电话</span>
                    <span class="msgCon">18015588011</span>
                  </div>
                  <div class="msgItem">
                    <img src="../assets/imgs/register/phone.png" alt />
                    <span class="msgTit">办公地址</span>
                    <span class="msgCon">绿地新都会</span>
                  </div>
                  <div class="msgItem">
                    <img src="../assets/imgs/register/phone.png" alt />
                    <span class="msgTit">工作时间</span>
                    <span class="msgCon">周一至周五 09:00 - 18:00</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom">
            <button class="downBut">登录</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      type: 2, //注册还是更换密码
      step: 1, //进度
      regContent: true,
      register: false,
      inputIndex: 0,
      blNum: "", //短信验证码
      phone: "",
      time: "",
      cName: "获取验证码",
      smsSent: false, //是否发送过验证码
      password: "",
      rpassword: "", //确认密码
      passdiff: false,
      passStrongType: 0,
      errorType: 0,
      errorTip: "",
      allFill: false, //表单全填满控制按钮高亮
      code: "",
      jumpTime: 3,
      differentPass: false,
    };
  },
  created () {
    this.getinfo();
  },
  methods: {
    inputChange (index) {
      this.inputIndex = index;
    },
    inputBlur () { },

    // 获取注册页面信息
    getinfo () {
      let data = {
        modeCode: "TyGGjyoIv5eAWi6XUZf2vE5s2Xiitz0U",
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.citylist = res.data.list;
        }
      });
    },
    // 下一步
    tijiao () {
      if (this.phone == "") {
        this.errorType = 1;
        this.errorTip = "请输入手机号";
        return;
      }
      if (this.blNum == "") {
        this.errorType = 2;
        this.errorTip = "请输入短信验证码";
        return;
      }
      if (this.password == "") {
        this.errorType = 3;
        this.errorTip = "请输入密码";
        return;
      }
      if (this.rpassword == "") {
        this.errorType = 4;
        this.errorTip = "请再次输入密码";
        return;
      }
      if (this.rpassword !== this.password) {
        this.errorType = 5;
        this.errorTip = "两次密码输入不一致";
        return;
      }
      let data = {
        modeCode: "XBsqHM0CkI0bRPmKGbIvwfljmFWGHj9S",
        code: this.blNum,
        phone: this.phone,
        passWord: this.password,
        pwdLevel: this.passStrongType
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.step = 2;
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    //按钮高亮
    isHigtLight () {
      if (
        this.phone != "" &&
        this.blNum != "" &&
        this.password != "" &&
        this.rpassword != ""
      ) {
        return true
      }
    },
    inputPhone () {
      this.errorType == 1 ? (this.errorType = 0) : this.errorType;
      this.allFill = this.isHigtLight();
    },
    inputSms () {
      this.errorType == 2 ? (this.errorType = 0) : this.errorType;
      this.allFill = this.isHigtLight();
    },
    passStrong () {
      this.errorType == 3 ? (this.errorType = 0) : this.errorType;
      this.allFill = this.isHigtLight();
      function checkStrong (val) {
        var modes = 0;
        if (val.length <= 0) return -1;
        if (val.length < 6) return 0;
        if (/\d/.test(val)) modes++; //数字
        if (/[a-z]/.test(val)) modes++; //小写
        if (/[A-Z]/.test(val)) modes++; //大写
        if (/\W/.test(val)) modes++; //特殊字符
        if (val.length > 12) modes++;
        return modes;
      }
      let hh = checkStrong(this.password);
      this.passStrongType = hh;
    },
    inputComfirm () {
      this.allFill = this.isHigtLight();
      this.errorType == 4 || this.errorType == 5 ?
        (this.errorType = 0) :
        this.errorType;
    },
    // 获取手机验证码
    getSms () {
      /**判断是否是手机号**/
      function isPhoneNumber (tel) {
        var reg = /^0?1[3|4|5|6|7|8][0-9]\d{8}$/;
        return reg.test(tel);
      }
      if (!isPhoneNumber(this.phone)) {
        this.errorType = 1;
        this.errorTip = "请输入正确手机号";
        return;
      }
      if (this.smsSent) {
        return;
      }

      let data = {
        modeCode: "zogmZBEuFbiXbcx0affPtovmmjFvXTfF",
        phone: this.phone,
        type: this.type == 1 ? "register" : "forgetPassword",
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.cName = "重新发送";
          this.smsSent = true;
          let stime = 60;
          this.time = stime;
          let timeId = setInterval(() => {
            this.time = stime--;
            if (stime < 0) {
              this.cName = "获取验证码";
              this.smsSent = false;
              this.time = "";
              clearInterval(timeId);
            }
          }, 1000);
          this.$Message.success("发送成功，请前往手机查看");
        } else {
          this.$Message.warning("发送失败，请60秒后重试");
        }
      });
    },
    // 注册
    registerBtn () {
      // if(this.phone == ""){
      // 	this.$Message.warning('请输入手机号');
      // 	return
      // }
      // if(this.code == ""){
      // 	this.$Message.warning('请输入验证码');
      // 	return
      // }
      // if(this.password == ""){
      // 	this.$Message.warning('请输入密码');
      // 	return
      // }
      // if(this.password != this.rpassword){
      // 	this.differentPass = true
      // }
      // if(this.password == this.rpassword){
      // 	this.differentPass = false
      // }

      let data = {
        enterpriseName: this.cityName,
        blNum: this.blNum,
        orgId: this.cityId,
        phone: this.phone,
        phoneCode: this.code,
        userPwd: this.password,
        modeCode: "Ykc4JgCx23RNfiEUsTSnJzwnqCqLgtNc",
      };
      this.$http.post(data).then((res) => {
        // if(res.code == 1){
        this.step = 3;
        let timeID = setTimeout(() => {
          this.$router.push("/login");
        }, 2000);
        // }
      });
    },
  },
  watch: {
    passWord: function (newValue, oldValue) {
      function checkStrong (val) {
        var modes = 0;
        if (val.length <= 0) return -1;
        if (val.length < 6) return 0;
        if (/\d/.test(val)) modes++; //数字
        if (/[a-z]/.test(val)) modes++; //小写
        if (/[A-Z]/.test(val)) modes++; //大写
        if (/\W/.test(val)) modes++; //特殊字符
        if (val.length > 12) return 4;
        return modes;
      }
      let hh = checkStrong(newValue);
      let item = document.querySelectorAll(".item");
      if (newValue != oldValue) {
        item[3].classList.remove("active");
        item[4].classList.remove("active");
        item[5].classList.remove("active");
      }

      if (hh == -1) {
        item[3].classList.remove("active");
      }
      if (hh == 0) {
        item[3].classList.add("active");
      }
      if (hh == 1 || hh == 2 || hh == 3) {
        item[3].classList.add("active");
        item[4].classList.add("active");
      }
      if (hh == 4) {
        item[3].classList.add("active");
        item[4].classList.add("active");
        item[5].classList.add("active");
      }
    },
  },
};
</script>

<style lang="less" scoped>
#register {
  .content {
    text-align: left;
  }

  header {
    height: 34px;
    line-height: 34px;
    background: #f7f9fd;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #616c84;
    letter-spacing: -0.43px;
  }

  .titleBox {
    margin: 30px auto;

    .left {
      display: flex;
      align-items: center;

      span {
        font-family: PingFangSC-Regular;
        font-size: 22px;
        color: #252a37;
        letter-spacing: 0.39px;
        margin: 0 20px;
      }
    }

    .right {
      font-family: PingFangSC-Regular;
      font-size: 18px;
      color: #000000;
      letter-spacing: 0.32px;

      a {
        font-family: PingFangSC-Regular;
        font-size: 18px;
        color: #2c59c3;
        letter-spacing: 0.26px;
        line-height: 25px;
      }
    }
  }

  /* 步骤条 */
  .progress {
    margin: 20px auto;
    border-bottom: 2px solid #d7dce7;
    padding: 0 380px;
    height: 35px;
    line-height: 30px;

    .item {
      width: 210px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 5px 12px;
      padding-bottom: 16px;

      span {
        margin-left: 10px;
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #4a4a4a;
        letter-spacing: 0.29px;
      }

      /* 步骤序号 */
      .step {
        width: 24px;
        height: 24px;
        line-height: 24px;
        background: #b0b5c1;
        color: #fff;
        border-radius: 50%;
        text-align: center;
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #ffffff;
        letter-spacing: 0.29px;
      }
    }

    .line {
      margin: 0 30px;
    }

    /* 进度条激活样式 */
    .item.active {
      border-bottom: 2px solid #2c59c3;
      margin-bottom: -2px;

      .step {
        background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.14);
      }
    }

    /* 进度条完成样式 */
    // .stepFinish {
    //   display: none;
    // }

    .stepFinish img {
      vertical-align: middle;
    }
  }

  /* 注册 */
  .registerBox {
    background: #ffffff;
    border-radius: 10px;
    width: 660px;
    height: 640px;
    margin: 40px auto;
    box-shadow: 0 10px 90px 0 rgba(29, 42, 67, 0.05);

    .title {
      text-align: center;
      font-family: PingFangSC-Semibold;
      font-size: 26px;
      color: #2c59c3;
      letter-spacing: 0.46px;
      padding: 17px 0;
      border-bottom: 1px solid #ebedf3;
    }

    .title p:nth-child(2) {
      font-weight: 600;
    }

    .inputBox {
      width: 368px;
      margin: 30px auto;

      .line {
        margin: 10px 0;

        .sms {
          width: 228px;
          height: 48px;
        }

        .getsms {
          width: 131px;
          height: 48px;
          line-height: 48px;
          background-image: linear-gradient(180deg, #fcfcfc 0%, #f5f5f5 100%);
          border: 1px solid #dfdfdf;
          border-radius: 8px;
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          letter-spacing: 0.3px;
          text-align: center;
          cursor: pointer;

          &:hover {
            background-image: linear-gradient(180deg, #fcfcfc 0%, #e3e4e4 100%);
          }
        }

        .sms-send {
          color: #666666;
        }

        .sms-sent {
          color: #c1c1c1;
          background: #fafbfb !important;
          border: 1px solid #f2f2f2;
          border-radius: 8px;
        }

        .errorTip {
          height: 26px;
          background: #dc554f;
          border-radius: 4px;
          font-family: PingFangSC-Semibold;
          font-size: 12px;
          color: #ffffff;
          letter-spacing: 0.22px;
          padding: 5px 9px;
          flex-wrap: nowrap;
          position: relative;
          top: -45px;
          float: right;
          right: 10px;
        }

        .errorTip2 {
          height: 26px;
          background: #dc554f;
          border-radius: 4px;
          font-family: PingFangSC-Semibold;
          font-size: 12px;
          color: #ffffff;
          letter-spacing: 0.22px;
          padding: 5px 9px;
          flex-wrap: nowrap;
          position: relative;
          top: -45px;
          float: right;
          right: 150px;
        }
      }

      .line p {
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #9097a9;
        letter-spacing: 0.3px;
      }

      input {
        width: 100%;
        height: 48px;
        line-height: 48px;
        border: 0;
        outline: none;
        padding-left: 24px;
        background: #ffffff;
        border: 1px solid #dfdfdf;
        box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.07);
        border-radius: 8px;
        margin: 8px 0;
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #4a4a4a;
      }

      input.active {
        border: 1px solid #2255ce;
      }

      input.error-active {
        border: 1px solid #dc554f !important;
      }
    }

    /* 密码强度 */
    .strength {
      width: 229px;
      height: 18px;
      background: #ffffff;
      border: 1px solid #dfdfdf;
      box-shadow: inset 0 0 3px 0 rgba(0, 0, 0, 0.17);
      border-radius: 8px;
      margin-bottom: 8px;

      .strongActive {
        background-image: linear-gradient(
          180deg,
          #fad961 0%,
          #f76b1c 100%
        ) !important;
      }

      .item {
        width: 74px;
        text-align: center;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #ffffff;
        letter-spacing: 0.22px;
        background-image: linear-gradient(0deg, #c6cfd6 0%, #f5f6f8 100%);
      }

      .item:first-child {
        border-radius: 8px 0 0 8px;
      }

      .item:last-child {
        border-radius: 0 8px 8px 0;
      }

      /* 强度激活样式 */
      .item.active {
        background-image: linear-gradient(180deg, #fad961 0%, #f76b1c 100%);
      }
    }
  }

  .input {
    position: relative;
  }

  .line .down {
    position: absolute;
    top: 30px;
    right: 10px;
  }

  .registerBox .inputBox .line.relative {
    position: relative;
  }

  /* 下拉框 */
  .line .selectBox {
    position: absolute;
    top: 65px;
    right: -10px;
    background: #ffffff;
    border: 1px solid #dadada;
    box-shadow: 0 14px 30px 0 rgba(0, 0, 0, 0.14);
    width: 240px;
    height: 270px;
    overflow-y: scroll;
    border-radius: 10px;

    li {
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #dadada;
      padding-left: 15px;
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #999999;
      letter-spacing: 0.26px;
    }

    li:hover {
      background: #fafafa;
      color: #4a4a4a;
    }
  }

  input:hover {
    border: 1px solid red;
  }

  /* 下一步按钮 */
  .next {
    width: 368px;
    height: 48px;
    line-height: 48px;
    margin: 30px auto;
    border: 1px solid #b2c9ff;
    border-radius: 8px;
    font-family: PingFangSC-Semibold;
    font-size: 18px;
    color: #ffffff;
    letter-spacing: 0.34px;
    cursor: pointer;
  }

  .next-active {
    background-image: linear-gradient(180deg, #478ee9 0%, #2255ce 100%);
  }

  .next-normal {
    background-image: linear-gradient(180deg, #d3e2ff 0%, #a8c2ff 100%);
  }

  /* 进度2 */
  .secondStep .title,
  .thirdStep .title {
    padding: 15px;
    font-weight: 600;
  }

  .secondStep {
    .inputBox {
      margin: 15px auto;
    }

    .content-box {
      width: 100%;
      height: 526px;

      img {
        width: 100px;
        height: 100px;
        margin: 84px 0 42px 0;
      }

      p {
        font-family: PingFangSC-Medium;
        font-size: 22px;
        color: #252a37;
        letter-spacing: 0.39px;
        text-align: center;

        span {
          color: #2c59c3;
          line-height: 30px;
          cursor: pointer;
        }
      }
    }

    .bottom {
      padding-top: 14px;
      border-top: 1px solid rgba(151, 151, 151, 0.1);
      text-align: center;
      font-family: PingFangSC-Medium;
      font-size: 12px;
      color: #9999a8;
      letter-spacing: 0.22px;

      .showAgree {
        color: #2d5ac3;
        cursor: pointer;
      }
    }

    /* 两次密码不一致 */
    .input {
      position: relative;

      .different {
        position: absolute;
        top: 20px;
        right: 0;
        font-family: PingFangSC-Semibold;
        font-size: 12px;
        color: #ffffff;
        background: #dc554f;
        border-radius: 4px;
        letter-spacing: 0.22px;
        height: 26px;
        line-height: 26px;
        padding: 0 15px;
      }
    }
  }

  /* 进度3 */
  .thirdStep {
    position: relative;
    height: 640px;

    .thirdContent {
      width: 52%;
      margin: 80px auto;
      text-align: center;

      .successMsg {
        font-family: PingFangSC-Medium;
        font-size: 22px;
        color: #252a37;
        letter-spacing: 0.39px;
        text-align: center;
        margin: 30px 0;

        a {
          color: #2c59c3;
        }
      }
    }

    .bottom {
      width: 100%;
      height: 40px;
      line-height: 40px;
      border-top: 1px solid rgba(151, 151, 151, 0.1);
      position: absolute;
      bottom: 0;
      font-family: PingFangSC-Medium;
      font-size: 12px;
      color: #9999a8;
      letter-spacing: 0.22px;
      text-align: center;
    }
  }

  /* 底部 */
  footer {
    width: 100%;
    margin: 40px 0 0;

    .top {
      height: 94px;
      background: #f7f9fd;

      .content {
        padding: 20px 0 0;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #616c84;
        letter-spacing: 0.22px;

        p {
          margin: 10px 0;
        }

        .bottomLogo {
          margin: 0 10px;
        }
      }
    }

    .bottom {
      height: 30px;
      line-height: 30px;
      background: #153684;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #ffffff;
      letter-spacing: 0.22px;
      text-align: center;
    }
  }

  /* 协议 */
  .agreement {
    margin: 30px auto;
    min-height: 718px;

    .back {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #adb2bc;
      letter-spacing: 0.26px;
      cursor: pointer;

      img {
        margin: 0 5px;
        vertical-align: middle;
      }
    }

    .agree {
      width: 875px;
      margin: 20px auto;

      .argeeTit {
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #4a4a4a;
        letter-spacing: 0.3px;
        text-align: center;
        font-weight: 600;
        padding: 20px 0;
        border-bottom: 1px solid #ebedf3;
      }

      .agreeCon {
        margin: 30px auto;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #252a37;
        letter-spacing: 0.25px;
        text-align: justify;
        line-height: 22px;

        .head {
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #252a37;
          letter-spacing: 0.25px;
          text-align: justify;
          font-weight: 600;
          margin: 8px 0;
        }

        p {
          margin: 5px 0;
        }
      }
    }
  }

  /* 弹出层 */
  .alert {
    width: 480px;
    height: 390px;
    background: #ffffff;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.04);
    border-radius: 10px;
    margin-top: -185px;
    margin-left: -240px;

    .alertContent {
      .title {
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #4a4a4a;
        letter-spacing: 0;
        text-align: center;
        padding: 15px 0;
        border-bottom: 1px solid #e9e9e9;
      }

      .middle {
        margin: 15px auto;
        text-align: center;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #252a37;
        letter-spacing: 0;

        .bg {
          background: url("../assets/imgs/register/alertbg.png") no-repeat;
          background-size: 100%;
          width: 408px;
          height: 140px;
          margin: 15px auto;
          text-align: center;
          padding: 10px 20px;

          .bgTitle {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #4a4a4a;
            letter-spacing: 0;
            padding-bottom: 10px;
            border-bottom: 1px solid #e9e9e9;
          }

          .msgBox {
            padding: 20px 40px;
            text-align: left;

            .msgItem {
              margin: 5px 0;

              img {
                vertical-align: middle;
                margin: 0 4px;
              }

              .msgTit {
                font-family: PingFangSC-Semibold;
                font-size: 14px;
                color: #9097a9;
                letter-spacing: 0;
                margin: 0 6px;
              }

              .msgCon {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #4a4a4a;
                letter-spacing: 0;
              }
            }
          }
        }
      }
    }

    .bottom {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 50px;
      line-height: 50px;
      background: #f5f5f5;
      border-radius: 0 0 10px 10px;
      text-align: center;

      .downBut {
        background-image: linear-gradient(180deg, #478ee9 0%, #2255ce 100%);
        border: 1px solid #285ed3;
        border-radius: 4px;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0;
        width: 138px;
        height: 30px;
        line-height: 30px;
      }
    }
  }
}
</style>
